function safeJSONParse(str: string, traceId = '') {
  try {
    return JSON.parse(str);
  } catch (e) {
    console.warn(`Invalid JSON. Could not parse: ${str}. TraceID: ${traceId}`);
  }
}

export { safeJSONParse };
